import { PropsWithChildren } from "react";

import UFOLoadHold from "@atlaskit/react-ufo/load-hold";

import { useUserContext } from "@/components/user-context/user-context-provider";

import { LoggedInHeroSkeleton } from "./logged-in-hero-skeleton";

export const LoggedInHeroContainer = ({ children }: PropsWithChildren) => {
    const {
        profile: { requestInProgress: profileRequestInProgress },
        user: { requestInProgress: userRequestInProgress }
    } = useUserContext();
    // Checking for both user and profile request in progress,
    // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
    if (userRequestInProgress || profileRequestInProgress) {
        return (
            <UFOLoadHold name={"logged-in-hero-loading"}>
                <LoggedInHeroSkeleton />
            </UFOLoadHold>
        );
    }
    return children;
};
